export const THEME_REQUEST = "THEME_REQUEST";
export const THEME_SUCCESS = "THEME_SUCCESS";
export const THEME_FAIL = "THEME_FAIL";

export const CREATE_THEME_REQUEST = "CREATE_THEME_REQUEST";
export const CREATE_THEME_SUCCESS = "CREATE_THEME_SUCCESS";
export const CREATE_THEME_FAIL = "CREATE_THEME_FAIL";
export const CREATE_THEME_STOP_LOADING = "CREATE_THEME_STOP_LOADING";

export const CRUMB_REQUEST = "CRUMB_REQUEST";
export const CRUMB_SUCCESS = "CRUMB_SUCCESS";
export const CRUMB_FAIL = "CRUMB_FAIL";

export const TOGGLE_DRAWER_REQUEST = "TOGGLE_DRAWER_REQUEST";
export const TOGGLE_DRAWER_SUCCESS = "TOGGLE_DRAWER_SUCCESS";
export const TOGGLE_DRAWER_FAIL = "TOGGLE_DRAWER_FAIL";

export const TOGGLE_THEME_LOADING_REQUEST = "TOGGLE_THEME_LOADING_REQUEST";
export const TOGGLE_THEME_LOADING_SUCCESS = "TOGGLE_THEME_LOADING_SUCCESS";
export const TOGGLE_THEME_LOADING_FAIL = "TOGGLE_THEME_LOADING_FAIL";
